import { Stack } from '../../../shared/ui/Stack/Stack';
import { Text } from '../../../shared/ui/Text/Text';
import styles from './InfoCard.module.scss';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 



export const InfoCard = () => {

    useGSAP(() => {
        gsap.fromTo(".titleInfo", {"--opacity": 0, "--x1": "0px", "--x2": "0px"}, 
                    {"--opacity": 1, "--x1": "60px", "--x2": "-60px", 
                    duration: 3, 
                    scrollTrigger: {
                        trigger: ".titleInfo"
        }});

        let mm =gsap.matchMedia();
        
        mm.add("(max-width: 1024px)", () => {
            gsap.fromTo(".titleInfo", {"--opacity": 0, "--x1": "0px", "--x2": "0px"  }, 
                {"--opacity": 1, "--x1": "20px", "--x2": "-20px", 
                duration: 3, 
                scrollTrigger: { 
                    trigger: ".titleInfo"
            }});
        })
        mm.add("(max-width: 420px)", () => {
            gsap.fromTo(".titleInfo", {"--opacity": 0, "--x1": "0px", "--x2": "0px"  }, 
                {"--opacity": 1, "--x1": "-10px", "--x2": "10px", 
                duration: 3, 
                scrollTrigger: { 
                    trigger: ".titleInfo"
            }});
        })

        }, [])


    
    return(
        <section className={styles.dark}>  
                    <Stack                         
                        justifyContent = 'justifyCenter' 
                        alignItems = 'alignCenter'                         
                        className={styles.container}                  
                    >
                        <Text size='xxl' className= {`titleInfo ${styles.title}`}>
                            ДОВЕРИЕ 
                        </Text>                           
                    </Stack>
        </section>
    )
}